//"whatwg-fetch" is module fot adapt fetch to IE
import { fetch as fetchPolyfill } from "whatwg-fetch";
import store from "../store";
import ErrorService from "./ErrorService";
import $ from "jquery";
import BaseService from "./BaseService";
import Utils from "../helpers/utils";

export default class PostSurveyService extends BaseService {
  prepareQnas(qnasArr) {
    let qnaStr = "";
    qnasArr.forEach((it) => {
      if (+it.ID > 0 && it.surveyAns && it.surveyAns !== "") {
        qnaStr = qnaStr.concat(`${it.ID}-${it.surveyAns};`);
      }
    });
    return qnaStr;
  }
  getPostObj(body) {
    return {
      method: "POST",
      body: body.join("&"),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
  }
  dec2hex(str){ // .toString(16) only works up to 2^53
    try {
      var dec = str.toString().split(''), sum = [], hex = [], i, s
      while(dec.length){
          s = 1 * dec.shift()
          for(i = 0; s || i < sum.length; i++){
              s += (sum[i] || 0) * 10
              sum[i] = s % 16
              s = (s - sum[i]) / 16
          }
      }
      while(sum.length){
          hex.push(sum.pop().toString(16))
      }
      return '0x' + hex.join('')
    } catch (err) {
      return null;
    }
  } 
  async sendPostSurvey(
    qnasArr,
    url,
    surveyType,
    callId,
    surveyId,
    tenantId,
    sccallId
  ) {
    let qnasStr = this.prepareQnas(qnasArr);
    let sendObj = {};
    let formBody = [];
    let callIdToHex = callId ? (callId.startsWith('0x') ? callId : this.dec2hex(callId)) : null;
    sendObj.callId = "";
    sendObj.surveyId = surveyId;
    sendObj.tenantId = tenantId;
    sendObj.surveyAns = qnasStr;
    sendObj.surveyType = surveyType;
    if (callIdToHex) {
      if (callIdToHex.startsWith('0x'))
        sendObj.sccallId = callIdToHex;
      else
        sendObj.sccallId = `0x${callIdToHex}`;
    }
    else
      sendObj.sccallId = sccallId; // e.g. CC/SC integration

    for (var property in sendObj) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(sendObj[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }

    try {
      await this.performRequest(url, this.getPostObj(formBody));
    } catch (e) {
      throw new Error(e);
    }
  }

  async performRequest(url, body) {
    try {
      const response = await fetchPolyfill(url, body);
      const text = await response.text();
      const str = await new window.DOMParser().parseFromString(
        text,
        "text/xml"
      );
      if (
        str.firstChild.firstChild &&
        str.firstChild.firstChild.textContent.toUpperCase() !== "SUCCESS"
      ) {
        if (str.firstChild.getElementsByTagName("pre")) {
          throw new Error(
            `Faild to Save data ${
              str.firstChild.getElementsByTagName("pre")[0].textContent
            }`
          );
        } else {
          throw new Error(`Faild to Save data`);
        }
      }
      return str;
    } catch (e) {
      ErrorService.displayAlert(e.message);
      Utils.log.error(e);
      throw new Error(e);
    }
  }
}
